import type { UseMultisiteDashboardUserSettingsParams } from './types';

export type MultisiteDashboardUserSettingsQueryKey = readonly [
  'users',
  'multisiteDashboardUserSettings',
  UseMultisiteDashboardUserSettingsParams,
];

export type MultisiteDashboardUserSettingsMutationKey = readonly [
  'users',
  'multisiteDashboardUserSettings',
  'update',
  UseMultisiteDashboardUserSettingsParams,
];

export const getMultisiteDashboardUserSettingsQueryKey = (
  params: UseMultisiteDashboardUserSettingsParams,
): MultisiteDashboardUserSettingsQueryKey => [
  'users',
  'multisiteDashboardUserSettings',
  params,
];

export const getMultisiteDashboardUserSettingsMutationKey = (
  params: UseMultisiteDashboardUserSettingsParams,
): MultisiteDashboardUserSettingsMutationKey => [
  'users',
  'multisiteDashboardUserSettings',
  'update',
  params,
];
